import React from 'react';
import type { TimeFilterKey } from '../data/constants.js';
import './time-filter.css';

interface TimeFilterProps {
  selected: TimeFilterKey;
  onChange: (key: TimeFilterKey) => void;
}

const OPTIONS: { key: TimeFilterKey; label: string }[] = [
  { key: 'all', label: 'ALL TIME' },
  { key: '90d', label: '90 DAYS' },
  { key: '30d', label: '30 DAYS' },
];

export function TimeFilter({ selected, onChange }: TimeFilterProps): React.ReactElement {
  return (
    <div className="mc-time-filter">
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          className={`mc-time-filter__btn${selected === o.key ? ' mc-time-filter__btn--active' : ''}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
